<div class="row">
    <div class="col-12 col-lg-6">
        <lookupvalues-form
            [type]="type"
            [header]="header"
            (refreshTable)="refreshTable()"
        ></lookupvalues-form>
    </div>
    <div class="col-12 clearfix d-lg-none"></div>
    <div class="col-12 col-lg-6">
        <data-table [dataset]="elements">
            <column [value]="'name'" [header]="'Name'"></column>
            <column [value]="'status'" [header]="'Status'"></column>
            <column
                [options]="options"
                [filterable]="false"
                [sortable]="false"
            ></column>
        </data-table>
    </div>
</div>
